var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"provider\"\u003E\u003Cprovider-table :providers=\"providers\" :meta=\"meta\" @load-data=\"loadProviders\"\u003E\u003C\u002Fprovider-table\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;